import { render, staticRenderFns } from "./EmailValidationModal.vue?vue&type=template&id=21d47fec"
import script from "./EmailValidationModal.vue?vue&type=script&lang=js"
export * from "./EmailValidationModal.vue?vue&type=script&lang=js"
import style0 from "./EmailValidationModal.vue?vue&type=style&index=0&id=21d47fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports